import { orchestrator } from 'satcheljs';
import { getBrowserWidth } from 'owa-config';
import {
    onCopilotChatDrawerOpened,
    COLLAPSE_FOLDER_PANE_WHEN_CHAT_OPENED_BREAKPOINT,
} from 'owa-copilot-chat-drawer-store';
import { type StateChangeSource } from 'owa-left-pane-layout/lib/types/StateChangeSource';
import { setShowFolderPane } from '../actions/setShowFolderPane';
import { shouldShowFolderPane } from '../selectors/shouldShowFolderPane';
import { isFeatureEnabled } from 'owa-feature-flags';

/**
 * Orchestrator for when Copilot Chat Drawer is opening. Used for any side effects for that state.
 *
 * Currently, main side effect is that folder pane should collapse when chat is opening. This is
 * beneath a flight, and is an experiment to give more space to the user when Chat is opened.
 */
orchestrator(onCopilotChatDrawerOpened, () => {
    if (
        isFeatureEnabled('mon-copilot-bizchat-drawer-leftnav-collapse') &&
        getBrowserWidth() < COLLAPSE_FOLDER_PANE_WHEN_CHAT_OPENED_BREAKPOINT &&
        shouldShowFolderPane() // if FP is shown
    ) {
        setShowFolderPane(false /* showFolderPane */, 9);
    }
});
